import { useState } from "react";
import { api } from "@/lib/api";
import { adminApi } from "@/lib/adminAuth";
import { toast } from "sonner";
import { Send } from "lucide-react";

const ZODIACS = ["", "Koç", "Boğa", "İkizler", "Yengeç", "Aslan", "Başak", "Terazi", "Akrep", "Yay", "Oğlak", "Kova", "Balık"];

export default function AdminPushBroadcast() {
  const [title, setTitle] = useState("FalZilla");
  const [body, setBody] = useState("");
  const [zodiac, setZodiac] = useState("");
  const [sending, setSending] = useState(false);
  const [lastResult, setLastResult] = useState(null);

  const send = async () => {
    if (!body) return toast.error("Mesaj gir");
    setSending(true);
    try {
      const { data } = await api.post("/admin/push/broadcast", { title, body, zodiac: zodiac || undefined }, adminApi());
      setLastResult(data);
      toast.success(`${data.targeted} kullanıcıya gönderim yapıldı`);
    } catch (e) { toast.error("Hata"); }
    finally { setSending(false); }
  };

  return (
    <div className="font-admin-body max-w-2xl">
      <h1 className="font-admin-head text-3xl mb-2">Push Bildirim</h1>
      <p className="text-sm text-white/60 mb-6">
        Expo Push Notification üzerinden mobil uygulama kullanıcılarına anlık bildirim gönder.
        (Web kullanıcıları için ayrı web-push altyapısı gerekir.)
      </p>

      <div className="admin-card p-5 space-y-4">
        <div>
          <label className="text-xs text-white/50">Başlık</label>
          <input value={title} onChange={(e) => setTitle(e.target.value)} data-testid="push-title" className="admin-input" />
        </div>
        <div>
          <label className="text-xs text-white/50">Mesaj</label>
          <textarea value={body} onChange={(e) => setBody(e.target.value)} rows={3} data-testid="push-body" className="admin-input" placeholder="Bugünkü yorumun hazır ✧" />
        </div>
        <div>
          <label className="text-xs text-white/50">Burç Filtresi (opsiyonel)</label>
          <select value={zodiac} onChange={(e) => setZodiac(e.target.value)} data-testid="push-zodiac" className="admin-input">
            {ZODIACS.map((z) => <option key={z || "all"} value={z}>{z || "— Tüm kullanıcılar —"}</option>)}
          </select>
        </div>
        <button onClick={send} disabled={sending} data-testid="push-send-btn" className="admin-btn flex items-center gap-2">
          <Send className="w-4 h-4" /> {sending ? "Gönderiliyor..." : "Gönder"}
        </button>
      </div>

      {lastResult && (
        <div className="admin-card p-4 mt-4 text-sm">
          <div>Hedeflenen: <strong>{lastResult.targeted}</strong> kullanıcı</div>
          <pre className="text-xs text-white/60 mt-2 overflow-x-auto">{JSON.stringify(lastResult.expo, null, 2)}</pre>
        </div>
      )}
    </div>
  );
}
